<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  components:{
  },
  data () {
    return {
    }
  }
}
</script>

<style>
html,body{
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100vh;

}

#app{
  width: 100%;
  height: 100%;
  font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
}
</style>




// WEBPACK FOOTER //
// src/App.vue